import { deleteCookie, getCookie } from '@/shared/utils/cookie';
import { isPrivateLink } from '@/shared/utils/private-link';

// Wire format set by the SSO callback on the public domain right before
// it redirects back to <tenant>.privatelink.celerdata.com:
//
//   x-sr-aid===<accountId>&&&x-sr-token===<token>&&&x-sr-ubid===<ubid>
//
// Both separators are part of the cross-domain contract — the public-
// domain writer and this drain MUST agree.
const ENTRY_SEPARATOR = '&&&';
const KV_SEPARATOR = '===';

// On the private-link SSO return path, the SSO callback writes session
// tokens into the `privateLinkLoginResult` cookie (scoped to the public
// `celerdata.com` domain) and bounces the browser to the private-link
// subdomain. Drain the cookie into localStorage before the host fetches
// the user, so `fetchInfo()` sees the ubid and the user lands on the
// requested page instead of getting bounced to `/login`.
export function drainPrivateLinkLoginCookies(): void {
  if (!getCookie('privateLinkLogin') || !isPrivateLink()) return;
  const result = getCookie('privateLinkLoginResult');
  if (result) {
    for (const item of result.split(ENTRY_SEPARATOR)) {
      if (!item) continue;
      const [k, v] = item.split(KV_SEPARATOR);
      if (k && v) localStorage.setItem(k, v);
    }
  }
  deleteCookie('privateLinkLogin');
  deleteCookie('privateLinkLoginResult');
}
